import { useSelector } from 'react-redux';

export const useCompareVehiclesList = () => {
	return useSelector((state) => state?.compareVehicles?.compareVehicles);
};
